module.exports = __webpack_public_path__ + "img/product_15.626c69b.svg";